<template>
     <div id="app" :class="{'ia-art': isInfinite }">
        <div class="page-skwebmdton">
           <RouteDef />
           <PageData />
           <NoSsr>
              <Omniture :not-pageview="true" />
           </NoSsr>
        </div>
        <header
           class="global-header"
           role="banner"
           tabindex="-1"
           data-js="global-header"
           >
           
           		   
		              <WebmdRow
		                 :span="24"
		                 id="ContentPane0"
		                 class="pane"
		                 tabindex="-1"
		                 >
		                 
                            <WebmdSiteFrontStyleConfig chronic-id="091e9c5e81d15a01"/>
                            
		              </WebmdRow>
		   		   
                      
           		   
		              <WebmdRow
		                 :span="24"
		                 id="ContentPane1"
		                 class="pane"
		                 tabindex="-1"
		                 >
		                 
                            <WebmdGlobalHeader chronic-id="091e9c5e813b6dde"/>
                            
		              </WebmdRow>
		   		   
                      
           		   
                      
           		   
                      
           		   
                      
           		   
                      
           		   
                      
           		   
                      
           		   
                      
           		   
                      
        </header>
        <WebmdRow
          class="container global-container-1"
          tabindex="-1"
          data-js="global-container-1"
          >
          
          		  
		             <WebmdRow
		                :span="24"
		                id="ContentPane10"
		                class="pane"
		                tabindex="-1"
		                >
		                
                            <WebmdVueAd chronic-id="091e9c5e8137aeea"/>
                            
		             </WebmdRow>
		  		  
                    
          		  
                    
          		  
                    
          		  
                    
          		  
                    
          		  
                    
          		  
                    
          		  
                    
          		  
                    
        </WebmdRow>
        <main
           id="global-main"
           role="main"
           tabindex="-1"
           data-js="global-main"
           class="resp-2-col-rr"
           >
           <WebmdRow
              :span="24"
              >
              <WebmdCol
                 :xs="24"
                 :sm="24"
                 :md="17"
                 :lg="13"
                 :xl="13"
                 id="main-container"
                 tabindex="-1"
                 class="main-container main-container-2"
                 data-js="main-container-2"
                 >
                 
                 				 
                 				 
                 				 
				                  <WebmdRow
				                     id="ContentPane29"
				                     class="pane"
				                     tabindex="-1"
				                     >
				                     
                                        <WebmdGlobalBreadcrumb chronic-id="091e9c5e81394036"/>
                                        
                                        <WebmdVueSubnav chronic-id="091e9c5e8252b545"/>
                                        
				                  </WebmdRow>
				                  
                 				 
                 				 
				                  <WebmdRow
				                     id="ContentPane30"
				                     class="pane"
				                     tabindex="-1"
				                     >
				                     
                                        <WebmdMedicalReference chronic-id="091e9c5e81e4bc93"/>
                                        
				                  </WebmdRow>
				                  
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
				                  <WebmdRow
				                     id="ContentPane36"
				                     class="pane"
				                     tabindex="-1"
				                     >
				                     
                                        <WebmdVueAd chronic-id="091e9c5e813fd8a3"/>
                                        
                                        <WebmdVueAd chronic-id="091e9c5e813fd8a4"/>
                                        
				                  </WebmdRow>
				                  
                 				 
              </WebmdCol>
              <div
                 class="main-container main-container-3"
                 tabindex="-1"
                 data-js="main-container-3"
                 >
                 
                 				 
				                  <WebmdRow
				                     id="ContentPane37"
				                     class="pane"
				                     tabindex="-1"
				                     >
				                     
                                        <WebmdInteractiveUnifiedRightRail chronic-id="091e9c5e8233d661"/>
                                        
                                        <WebmdInteractiveUnifiedRightRail chronic-id="091e9c5e8233d662"/>
                                        
                                        <WebmdGlobalAttribution chronic-id="091e9c5e81437ec1"/>
                                        
                                        <WebmdVueAd chronic-id="091e9c5e8137aeec"/>
                                        
				                  </WebmdRow>
				                  
                 				 
                 				 
				                  <WebmdRow
				                     id="ContentPane38"
				                     class="pane"
				                     tabindex="-1"
				                     >
				                     
                                        <ChannelTodayOnWebmd chronic-id="091e9c5e813ece15"/>
                                        
				                  </WebmdRow>
				                  
                 				 
                 				 
				                  <WebmdRow
				                     id="ContentPane39"
				                     class="pane"
				                     tabindex="-1"
				                     >
				                     
                                        <WebmdVueAd chronic-id="091e9c5e816e5f79"/>
                                        
				                  </WebmdRow>
				                  
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
                 				 
				                  <WebmdRow
				                     id="ContentPane43"
				                     class="pane"
				                     tabindex="-1"
				                     >
				                     
                                        <HtmlModule chronic-id="091e9c5e813ece18"/>
                                        
				                  </WebmdRow>
				                  
                 				 
                 				 
                 				 
                 				 
                 				 
              </div>
           </WebmdRow>
        </main>
        <WebmdRow
           :span="24"
           class="container global-container-2"
           tabindex="-1"
           data-js="global-container-2"
           >
           
           		   
		              <WebmdRow
		                 id="ContentPane46"
		                 class="pane"
		                 tabindex="-1"
		                 >
		                 
                            <WebmdBtmRecommendedModule chronic-id="091e9c5e813ece16"/>
                            
                            <ChannelTopPicks chronic-id="091e9c5e813ece14"/>
                            
                            <DesktopPromoModule chronic-id="091e9c5e826b1cac"/>
                            
                            <ExploreMoreModule chronic-id="091e9c5e826a54a3"/>
                            
                            <WebmdLhdCarefinder chronic-id="091e9c5e8141403f"/>
                            
		              </WebmdRow>
		   		   
                      
           		   
		              <WebmdRow
		                 id="ContentPane47"
		                 class="pane"
		                 tabindex="-1"
		                 >
		                 
                            <WebmdVueAd chronic-id="091e9c5e81641fd1"/>
                            
		              </WebmdRow>
		   		   
                      
           		   
                      
           		   
                      
           		   
                      
           		   
		              <WebmdRow
		                 id="ContentPane51"
		                 class="pane"
		                 tabindex="-1"
		                 >
		                 
                            <ChannelSeoLinks chronic-id="091e9c5e823edf65"/>
                            
		              </WebmdRow>
		   		   
                      
           		   
                      
           		   
                      
           		   
                      
        </WebmdRow>
        <footer
           role="contentinfo"
           tabindex="-1"
           data-js="global-footer"
           >
           
           		   
		              <WebmdRow
		                 id="ContentPane55"
		                 class="pane"
		                 tabindex="-1"
		                 >
		                 
                            <WebmdGlobalFooter chronic-id="091e9c5e8137e40d"/>
                            
		              </WebmdRow>
		              
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
           		   
        </footer>
  	   
  	   	   
	           <WebmdRow
	     			id="ContentPane99"
	                 class="pane"
	                 tabindex="-1"
	     			>
	     			
  			              <GlobalPlaceholderBottom chronic-id="091e9c5e8137aeed"/>
  			              
  			              <WebmdVueAd chronic-id="091e9c5e813aa1a8"/>
  			              
	           </WebmdRow>
	     	  
  	   	  
     </div>
</template>
<script>
import adsConsumer from 'webmd-ads-consumer';
import PageData from 'webmd-page-common/src/Component.vue';
import NoSsr from './client-only';
import { Col, Row, Container } from  'webmd-elements';
import { defineAsyncComponent } from 'vue';
import useStore from 'webmd-cms-store/src/store';
import RouteDef from  'webmd-cms-router/src/Component.vue';
import WebmdSiteFrontStyleConfig from  'webmd-site-front-style-config/src/Component.vue';
import WebmdGlobalHeader from  'webmd-global-header/src/Component.vue';
import WebmdVueAd from  'webmd-vue-ad/src/Component.vue';
import WebmdGlobalBreadcrumb from  'webmd-global-breadcrumb/src/Component.vue';
import WebmdVueSubnav from  'webmd-vue-subnav/src/Component.vue';
import WebmdMedicalReference from  'webmd-medical-reference/src/Component.vue';
import WebmdInteractiveUnifiedRightRail from  'webmd-interactive-unified-right-rail/src/Component.vue';
import WebmdGlobalAttribution from  'webmd-global-attribution/src/Component.vue';
import HtmlModule from  'html-module/src/Component.vue';
import WebmdBtmRecommendedModule from  'webmd-btm-recommended-module/src/Component.vue';
import DesktopPromoModule from  'desktop-promo-module/src/Component.vue';
import ExploreMoreModule from  'explore-more-module/src/Component.vue';
import GlobalPlaceholderBottom from  'global-placeholder-bottom/src/Component.vue';
    export default {
		name: 'app',
      data() {
         return {
			   store: {}
		   }
	   },
		components: {
			NoSsr,
			PageData,
			RouteDef,
			WebmdCol : Col,
		WebmdRow: Row,
		WebmdContainer: Container,
		   WebmdSiteFrontStyleConfig,
		   WebmdGlobalHeader,
		   WebmdVueAd,
		   WebmdGlobalBreadcrumb,
		   WebmdVueSubnav,
		   WebmdMedicalReference,
		   WebmdInteractiveUnifiedRightRail,
		   WebmdGlobalAttribution,
		   ChannelTodayOnWebmd:  defineAsyncComponent(() => import (/*  webpackChunkName: "non-critical" */'channel-today-on-webmd/src/Component.vue' )),
		   HtmlModule,
		   WebmdBtmRecommendedModule,
		   ChannelTopPicks:  defineAsyncComponent(() => import (/*  webpackChunkName: "non-critical" */'channel-top-picks/src/Component.vue' )),
		   DesktopPromoModule,
		   ExploreMoreModule,
		   WebmdLhdCarefinder:  defineAsyncComponent(() => import (/*  webpackChunkName: "non-critical" */'webmd-lhd-carefinder/src/Component.vue' )),
		   ChannelSeoLinks:  defineAsyncComponent(() => import (/*  webpackChunkName: "non-critical" */'channel-seo-links/src/Component.vue' )),
		   WebmdGlobalFooter:  defineAsyncComponent(() => import (/*  webpackChunkName: "non-critical" */'webmd-global-footer/src/Component.vue' )),
		   GlobalPlaceholderBottom
		},
		mounted() {
		import('webmd-first-impression').then((m) => {});

		  // call display when all ads have been defined.
		  Promise.all(this.$vue.adsPromiseQueue).then(() => {
			adsConsumer.display();
		  });
		 const self = this;
		  const elements = this.$el.querySelectorAll('[data-metrics-module]');
		  elements.forEach((el) => {
  				self.$bindMetrics(el, {});
		  });
		},
		created() {
   		this.store = useStore(this.$pinia);
	   },
      computed: {
			isInfinite() {
				return this.store.flow.isInfinite;
			}
		},
		errorCaptured: (err, vm, info) => {
			const requiredModules = [/WebmdGlobalHeader/];
			const componentTag = vm?.$vnode?.tag;
			const attributes = vm?.$attrs;
			const route = vm?.$route?.fullPath;
			const isRequiredModule = requiredModules.some(name => name.test(componentTag));

			console.log(JSON.stringify({
				category: 'PAGE_SSR_ERROR',
				error: err.toString() || 'Unable to render',
				tag: componentTag,
				info: info,
				attributes: attributes,
				stackTrace: err.stack,
				route: route,
			}));
			return isRequiredModule;
		},
    };
</script>

<style lang="scss">
body[data-content-masked] {
	overflow:hidden;
}

.global-container-1,
.global-container-2,
footer,
header,
main {
  clear: both;
}

main {
  margin: 0 auto;
  max-width: 77.5rem;
  position: relative;
  
}

.main-container {
  float: left;
  transition: 0.4s width ease;
  box-sizing: border-box;
}

.main-container-1 {
  display: none;
}

.main-container-2 {
  max-width: 68em;
  margin-left: auto;
  margin-right: auto;
  padding: 0 2.75rem 0 0;
  position: relative;
  width: calc(100% - 19.5em);
  @media screen and (min-width: 47.938em) and (max-width: 64em) {
    max-width: 100%;
    padding: 0;
    width: 100%;
  }

  .ad > div {
    width: 100%;
    @media screen and (min-width: 47.938em) and (max-width: 64em) {
      width: auto;
    }
  }
}

.main-container-3 {
  width: 312px;
  @media screen and (min-width: 47.938em) and (max-width: 64em) {
    clear: both;
    display: block;
    float: none;
    margin: 0 auto;
    max-width: 45.5rem;
    width: auto;
  }
}

@media screen and (max-width:63.938em) {
  html.print article footer .main-container-1.sources {
    display: block;
 }

  html.print article footer .main-container-1.sources .left-nav-toggle::before {
    content: '\e624';
  }

  .main-container-2 {
      padding-left: 0;
    }
}

@media screen and (max-width: 77.438em) {
   main {
      padding: 0 1.25rem;
   }
}

@media screen and (max-width:47.938em) {
   body {
      padding: 5rem 0 0;
   }

   main {
      padding: 1.25rem;
   }

   .main-container-2 {
      padding: 0;
      width: 100%;
   }

   .main-container-3 {
      display: block;
      width: 100%;
   }
}



@media print {
   [data-js=global-container-2],
   [data-js=global-footer],
   [data-js=main-container-1],
   [data-js=main-container-3],
   .global-nav__wrapper > *:not(.global-nav__logo),
   [data-js=main-container-2] [data-e2e=brdcrmb],
   .article [data-e2e=social-sharebar],
   .ad {
      display:none !important;
   }

   article {
      font-size: 1rem;
      line-height: 1.364;
   }

   article h1 {
      font-size: 2.182em;
      margin: 1rem 0;
   }
}

#ContentPane36 .ad.ad-5001 > div:first-child {
    border: 0px solid #e8e6e6!important;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    display: inline-block;
    padding: 0.25rem;
}

:lang(en) #ContentPane36 .ad.ad-5001>div:first-child:after {
    content: "";
}

#ContentPane36 .ad.ad-5000 > div:first-child {
    border: 0px solid #e8e6e6!important;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    display: inline-block;
    padding: 0.25rem;
}
:lang(en) #ContentPane36 .ad.ad-5000 > div:first-child:after {
    content: "";
}
@media screen and (min-width: 47.938em) and (max-width: 64em) {
   main {
      padding: 0.75rem 0rem;
   }  
}

</style>